import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Forms from "@/components/Forms";
import WhySharpin from "@/components/WhySharpin";
import Testimonials from "@/components/Testimonials";
import Terms from "@/components/Terms";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import TermsPage from "@/pages/TermsPage";
import Account from "@/pages/Account";

const Home = () => {
  const [formTab, setFormTab] = useState("request");
  const [presetService, setPresetService] = useState("");

  const goToForm = (tab, service = "") => {
    setFormTab(tab);
    setPresetService(service);
    setTimeout(() => {
      document.getElementById("join")?.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  return (
    <main className="bg-alabaster text-navy font-body overflow-x-clip">
      <Navbar onBookCare={() => goToForm("request")} />
      <Hero onBookCare={() => goToForm("request")} />
      <Marquee />
      <Services onBook={(service) => goToForm("request", service)} />
      <Pricing />
      <Forms
        activeTab={formTab}
        onTabChange={setFormTab}
        presetService={presetService}
      />
      <WhySharpin />
      <Testimonials />
      <Terms />
      <Footer />
      <WhatsAppFloat />
      <ChatWidget />
    </main>
  );
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/account" element={<Account />} />
    </Routes>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
